import React from 'react';

const Avatar = ({ name, imageUrl, className = '' }) => {
  // Function to get initials from name
  const getInitials = (fullName) => {
    if (!fullName) return 'NN'; // Default if no name is provided
    
    const names = fullName.trim().split(' ');
    if (names.length === 1) return names[0].charAt(0).toUpperCase();
    
    return `${names[0].charAt(0)}${names[names.length - 1].charAt(0)}`.toUpperCase();
  };

  // Background colors for the avatar
  const colors = [
    'bg-blue-100 text-blue-600',
    'bg-green-100 text-green-600',
    'bg-purple-100 text-purple-600',
    'bg-yellow-100 text-yellow-600',
    'bg-pink-100 text-pink-600',
    'bg-indigo-100 text-indigo-600'
  ];
  
  // Generate a consistent color based on the name
  const getColorClass = (str) => {
    if (!str) return colors[0];
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % colors.length;
    return colors[index];
  };

  const colorClass = getColorClass(name);
  const initials = getInitials(name);

  return (
    <div className={`inline-flex items-center justify-center rounded-full ${colorClass} ${className}`}>
      {imageUrl ? (
        <img 
          className="h-full w-full rounded-full object-cover" 
          src={imageUrl} 
          alt={name || 'User'} 
          onError={(e) => {
            // If image fails to load, show initials instead
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
      ) : null}
      <span className={`${imageUrl ? 'hidden' : 'flex'} items-center justify-center w-full h-full`}>
        {initials}
      </span>
    </div>
  );
};

export default Avatar;
